export const addOpacity = (color: string, opacity: number = 0.15): string => {
  const hexToRgb = (hex: string): number[] => {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b)
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
      ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
      : [0, 0, 0]
  }

  const isHex = color.startsWith('#')
  const isRgb = color.startsWith('rgb')

  let r: number, g: number, b: number

  if (isHex) {
    ;[r, g, b] = hexToRgb(color)
  } else if (isRgb) {
    const match = color.match(/\d+/g)
    if (match) {
      ;[r, g, b] = match.map(Number)
    } else {
      throw new Error('Invalid RGB color format')
    }
  } else {
    throw new Error('Invalid color format. Use hex or RGB.')
  }

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const tagColors = [
  '#662D91',
  '#778899',
  '#F0AC42',
  '#39B54A',
  '#00ACEE',
  '#CBAE67',
  '#C49A6D',
  '#533D2F',
  '#ED1C24',
  '#E88A97',
  '#F28E1E',
  '#8DC63F',
  '#216C2A',
  '#D5A94C',
  '#FFE251',
  '#00A79D',
  '#52808B',
  '#ED1B33',
  '#142B55',
  '#E00686',
  '#505855',
  '#F7941E',
]
